// requestSearch.js — the Requests tab search box.
//
// Several terms separated by commas (or "|") match ANY of them, so
// "gampad, prebid, liftoff" narrows the list to those vendors and the header
// checkbox + ⬇ downloads exactly that set. Each term matches the URL, host,
// path, method, request type, the SDK-bidding buyer name, a vendor alias
// (a buyer's brand is often not in its hostname: Liftoff serves from
// vungle.com), or a param key pattern (`imafw_*`, see paramMatch.js).
// Works the same for proxied and USB/logcat rows: it reads only URL-level
// fields both carry.

import { rowMatchesParam } from './paramMatch';

// brand -> strings that identify it in a request. Lowercase.
const VENDOR_ALIASES = {
  liftoff: ['vungle', 'liftoff'],
  vungle: ['vungle', 'liftoff'],
  meta: ['facebook.com', 'fbcdn', 'meta audience'],
  facebook: ['facebook.com', 'fbcdn', 'meta audience'],
  gam: ['doubleclick.net', 'gampad'],
  aps: ['amazon-adsystem'],
  amazon: ['amazon-adsystem'],
  applovin: ['applovin'],
  unity: ['unityads', 'unity3d'],
  ironsource: ['ironsrc', 'ironsource'],
  inmobi: ['inmobi'],
  mintegral: ['mintegral', 'rayjump'],
  pangle: ['pangle', 'byteoversea', 'pangleglobal'],
  moloco: ['moloco'],
};

export function splitSearchTerms(query) {
  return String(query || '')
    .split(/[,|]/)
    .map((t) => t.trim())
    .filter(Boolean);
}

function hostPath(url) {
  try { const u = new URL(url); return { host: u.host, path: u.pathname }; } catch { return { host: '', path: '' }; }
}

function termMatches(r, term) {
  const t = term.toLowerCase();
  const vd = r.validData || {};
  const { host, path } = hostPath(r.url);
  const hay = [r.method, host, path, r.type, r.requestType, r.url, vd.networkName, vd.networkId, r.adVendor]
    .map((x) => String(x || '').toLowerCase());
  if (hay.some((x) => x.includes(t))) return true;
  const aliases = VENDOR_ALIASES[t];
  if (aliases && hay.some((x) => aliases.some((a) => x.includes(a)))) return true;
  return rowMatchesParam(r, term);
}

/** true when the row matches ANY term of the query (empty query matches all). */
export function rowMatchesSearch(r, query) {
  const terms = splitSearchTerms(query);
  if (!terms.length) return true;
  return terms.some((t) => termMatches(r || {}, t));
}
